import { parseServerError } from './parseServerError';

const KNOWN_PATTERNS = [
  {
    test: /reporting month is closed or not available/i,
    key: 'LedgerInvoiceErrorReportingMonthClosed',
  },
  {
    test: /No Tax-Authority token/i,
    key: 'LedgerInvoiceErrorNoTaxAuthorityToken',
  },
  {
    test: /Ledger .+ not found/i,
    key: 'LedgerInvoiceErrorLedgerNotFound',
  },
  {
    test: /Payment .+ not found in ledger/i,
    key: 'LedgerInvoiceErrorPaymentNotFound',
  },
  {
    test: /Client not found for/i,
    key: 'LedgerInvoiceErrorClientNotFound',
  },
  {
    test: /No client for case/i,
    key: 'LedgerInvoiceErrorClientNotFound',
  },
  {
    test: /Failed to create confirmation number/i,
    key: 'LedgerInvoiceErrorConfirmationNumberFailed',
  },
  {
    test: /Decision failed/i,
    key: 'LedgerInvoiceErrorDecisionFailed',
  },
  {
    test: /Cannot create (Expenses|income)/i,
    key: 'LedgerInvoiceErrorDocumentCreateFailed',
  },
];

/**
 * Maps a raw server error from GenerateLedgerInvoices to a translated user message.
 */
export function translateLedgerInvoiceError(rawError, t) {
  if (!rawError) return t('TaskFailed');

  const msg = String(rawError).trim();

  const { code } = parseServerError(msg);
  if (code) {
    const taxKey = `TaxInvoiceError${code}`;
    const taxMsg = t(taxKey);
    if (taxMsg && taxMsg !== taxKey) return taxMsg;
  }

  for (const { test, key } of KNOWN_PATTERNS) {
    if (test.test(msg)) return t(key);
  }

  return msg;
}

/**
 * Builds a de-duplicated, newline-separated list of translated failure messages.
 * Each line is prefixed with the client name (falling back to the caseId) when the
 * backend provides it, so the user can see which client each error belongs to.
 */
export function formatLedgerInvoiceFailureDetails(failures, t) {
  if (!Array.isArray(failures) || !failures.length) return '';

  const lines = failures
    .map((f) => {
      const message = translateLedgerInvoiceError(f?.error ?? f?.Error ?? '', t);
      if (!message) return '';
      const who = f?.clientName ?? f?.ClientName ?? f?.caseId ?? f?.CaseId ?? '';
      return who ? `${who}: ${message}` : message;
    })
    .filter(Boolean);

  return [...new Set(lines)].join('\n');
}
